import {FlowFreeSpinsState, FlowModuleEvents, WinPresentationEvents, GenericPopupEvents} from '@gongxigames/framework/slot';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {GameLogic} from 'src/server/GameLogic';
import {GameFlowModuleEvents} from 'src/win/GameFlowModuleEvents';
import {RandomWildEvents} from 'src/randomWild/RandomWildEvents';
import {Spin} from 'com/gongxigames/math/core/game/Spin';
import {Bonus} from 'com/gongxigames/math/core/game/engine/bonus/Bonus';

export class GameFlowFreeSpinsState extends FlowFreeSpinsState {
    protected setupEvents(): void {
        super.setupEvents();
    }

    protected onAllReelsStopped(): void {
        if ((this.module.logic as GameLogic).isRandomWildFeature()) {
            this.setupFeaturesSequence();
        } else {
            super.onAllReelsStopped();
        }
    }

    protected setupFeaturesSequence(): void {
        this.emit(GameFlowModuleEvents.START_RANDOM_WILD_FEATURE);
        this.addCallbackToWaitingLIst(RandomWildEvents.RANDOM_WILD_FEATURE_FINISHED, this.onDecideNextStep.bind(this));
    }

    protected onDecideNextStep(): void {
        this.clearEventsQueue();
        switch (this.module.logic.nextAction) {
            case Action.FREESPIN: {
                this.setupFreeGamesSequence();
                break;
            }
            // free spins finished
            case Action.SPIN: {
                this.setupEndFreeGamesSequence();
                break;
            }
            case Action.PICK: {
                this.emit(FlowModuleEvents.BONUS_GAME_WON);
                this.setupPickBonusSequence();
                break;
            }
            case Action.RESPIN: {
                this.setupRespinBonusSequence();
                break;
            }
            default:
                break;
        }
    }

    protected setupRetriggerSequence(): void {
        const fsWon: number = this.module.logic.getRetriggerCount();

        if (this.isWin()) {
            if (this.isBigWin()) {
                this.setupRetriggerWithBigWin(fsWon);
            } else {
                this.setupRetriggerWithWin(fsWon);
            }
        } else {
            this.setupRetriggerWithNoWin(fsWon);
        }
    }

    protected setupRetriggerWithNoWin(fsWon: number): void {
        this.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents.FREESPINS_RETRIGGER_WIN, fsWon);
        this.addEventToWaitingList(GenericPopupEvents.POPUP_CLOSED, FlowModuleEvents.SHOULD_START_INDIVIDUAL_WIN_AFTER_POPUP_FREESPINS);
        this.addEventToWaitingList(WinPresentationEvents.PAY_ANIMATIONS_AND_WIN_METER_FINISHED, FlowModuleEvents.CAN_SPIN);
        this.addEventToWaitingList(WinPresentationEvents.ALL_PAY_ANIMATIONS_FINISHED, FlowModuleEvents.CAN_SPIN);
        this.emit(FlowModuleEvents.WON);
    }

    protected restoreFreeSpinsWinningRoundWinPresentation(): void {
        const logic = this.module.logic as GameLogic;
        const fgBonus = logic.getFreeGames();

        if (fgBonus.isBuyBonus()) {
            return;
        }
        const spin: Spin = logic.getSessionForPickBonusWinningRound(Bonus.FREE_GAMES_BONUS);

        this.emit(FlowModuleEvents.WP_RESTORE, spin);
    }
}
